import './App.css';
import supabase from './supabaseClient';
import React, { useEffect, useState } from "react";
import logUserAction from "./Logging";


//var selectedCategory = 'NA';
var currentuserid = '';


let paramString = window.location.href.split('?')[1];
if (paramString) {
  let queryString = new URLSearchParams(paramString);
  for (let pair of queryString.entries()) {
    if (pair[0] === 'CategoryName') {
      //selectedCategory = pair[1];
    }
    if (pair[0] === 'userid') {
      currentuserid = pair[1];
      document.getElementById('userid-label').innerText = currentuserid;
    }
  }
}

function navigatetoVoucherHistoryPage() {
  logUserAction(currentuserid,'Profile page: clicked Points weightage History button on myscore page');
  window.location.href = window.location.pathname + "?pageName=PointsWeightage&userid=" + currentuserid;
  return;
};

function MyScore() { 
  const KC_SERVICE = process.env.REACT_APP_KC_SERVICE || 'https://kc-service-eight.vercel.app'; // https://kc-service-eight.vercel.app // http://localhost:3000

  const [overallScore, setOverallScore] = useState(0);
  const [data, setResponses] = useState([]);
  const [pointsWeightage, setPointsWeightage] = useState([]);

  useEffect(() => {
    async function fetchPointsWeighage() {
      const response = await fetch(KC_SERVICE + '/vouchers_getActivePointsWeightage', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ userId: currentuserid.split('-')[0] }),
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
      const result = await response.json();
      console.log('Fetched PointsWeightage:', result);
  
      setPointsWeightage(result.PointsWeightage || []);
      //setLoading(false);
    }
    fetchPointsWeighage();
  },[KC_SERVICE] );  

  useEffect(() => {
    async function fetchScore() {
      if (!currentuserid) return;
      const { data, error } = await supabase
        .from('UserResponses')
        .select('id, PointsReceived, QuestionID, Response, ResponseDateTime, Questions(QuestionText)')
        .eq('userid', currentuserid.split('-')[0])
        .is('voucherid', null)
        .eq('PointsRedeemed', false);

      if (error) {
        setOverallScore(0);
        setResponses([]);
        return;
      }

      const total = data?.reduce((sum, row) => sum + (row.PointsReceived || 0), 0) || 0;
      setOverallScore(total);
      setResponses(data || []);
    }

    fetchScore();
  }, ); //[currentuserid]

  const [voucher_process_status, setvoucher_process_status] = React.useState(true);
  
  React.useEffect(() => {
    async function fetchAppConfig() {
      
      const { data: config } = await supabase
      .from('AppConfig')
      .select('value')
      .eq('key', 'voucher_active')
      .single();

      //alert(config);
      if (config) {
        setvoucher_process_status(config.value === "true");
      }
    }
    fetchAppConfig();
  }, []);

  const handleRedeem = async () => {
    // check if AppConfig allows redeeming points. look for record with key 'voucher_process_status' if it value is 'active' then proceed else alert user that voucher process is currently inactive
    const { data: config, error: configError } = await supabase
      .from('AppConfig')
      .select('value')
      .eq('key', 'voucher_process_status')
      .single();

    if (configError || !config || config.value !== 'active') {
      alert(config.value);
      return;
    }

    // 1. Insert a dummy voucher
    // Log voucher data before insert
    const voucherData = {
      userid: currentuserid.split('-')[0],
      vouchernumber: 'DUMMY-' + Math.random().toString(36).substr(2, 8),
      type: 'myscore',
      amount: overallScore * pointsWeightage.map((item) => `${item.weightage}`).join(', '),
      retailer: 'Generic',
      // date: new Date().toISOString(),
      active: true,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      totalpointsredeemed: overallScore,
      pointsweightage: pointsWeightage.map((item) => `${item.weightage}`).join(', ')
    };
    // console.log('Voucher insert data:', voucherData);

    const { data: voucher, error: voucherError } = await supabase
      .from('Vouchers')
      .insert([voucherData])
      .select()
      .single();

    if (voucherError || !voucher) {
      alert("Failed to generate voucher. Please try again." + voucherError?.message); ;
      return;
    }

    // 2. Update UserResponses: set PointRedeemed=true and voucherid
    const responseIds = data.map(row => row.id);
    // console.log('Response IDs to update:', responseIds);

    await supabase
      .from('UserResponses')
      .update({
        PointsRedeemed: true,
        voucherid: voucher.id
      })
      .in('id', responseIds)
      .eq('userid', currentuserid.split('-')[0])
      .is('voucherid', null)
      .eq('PointsRedeemed', false);

    alert("Points redeemed! You will receive your gift voucher soon. You can see the status of voucher request in Vouchers section.");
    window.location.reload();
  };

  return (
    <div className="myscore-container" style={{ padding: "24px" }}>
      <h2>My Overall Score</h2>
      <div
        style={{
          fontSize: "2.5rem",
          fontWeight: "bold",
          color: overallScore >= 50 ? "#2e7d32" : "#c62828",
          background: overallScore >= 50 ? "#e8f5e9" : "#ffebee",
          borderRadius: "12px",
          padding: "24px",
          margin: "24px 0",
          textAlign: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
        }}
      >
        {overallScore}
        <div style={{ fontSize: "1.2rem", marginTop: "12px" }}>
          {overallScore >= 50
            ? "🎉 Great job! Keep up the excellent work!"
            : "Keep striving! Every point matters, and improvement is within reach!"}
        </div>
      </div>
      <h3 style={{ marginTop: "32px" }}>My Responses (Unredeemed Points)</h3>
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "16px" }}>
        <thead>
          <tr>
            <th style={{ borderBottom: "2px solid #ddd", padding: "12px", textAlign: "left" }}>Question</th>
            <th style={{ borderBottom: "2px solid #ddd", padding: "12px", textAlign: "left" }}>Response</th>
            <th style={{ borderBottom: "2px solid #ddd", padding: "12px", textAlign: "left" }}>Points</th>
            <th style={{ borderBottom: "2px solid #ddd", padding: "12px", textAlign: "left" }}>Date</th>
          </tr>
        </thead>
        <tbody>
          {data && data.map((row, index) => (
            <tr key={index}>
              <td style={{ padding: "12px", borderBottom: "1px solid #ddd" }}>{row.Questions?.QuestionText}</td>
              <td style={{ padding: "12px", borderBottom: "1px solid #ddd" }}>{row.Response}</td>
              <td style={{ padding: "12px", borderBottom: "1px solid #ddd" }}>{row.PointsReceived}</td>
              <td style={{ padding: "12px", borderBottom: "1px solid #ddd" }}>{new Date(row.ResponseDateTime).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {voucher_process_status && (
        <div style={{ textAlign: "center", marginTop: "32px" }}>
          <div style={{ marginTop: "16px", padding: "12px", background: "#f1f8e9", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
            <p style={{ margin: "0", fontSize: "1rem", color: "#2e7d32", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <span>
                Current weightage: {pointsWeightage.map((item) => `${item.weightage}`).join(', ')}. 
                Estimated voucher value: {overallScore * (pointsWeightage.reduce((acc, item) => acc + item.weightage, 0) || 1)}.
                You may redeem your points now or wait for updated weightage.
              </span>
              <button
                style={{
                  marginLeft: "16px",
                  background: "#1976d2",
                  color: "#fff",
                  padding: "8px 16px",
                  fontSize: "0.9rem",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  boxShadow: "0 2px 8px rgba(25, 118, 210, 0.15)",
                  transition: "background 0.2s"
                }}
                onClick={() => navigatetoVoucherHistoryPage()}
              >
                View Historical Rates
              </button>
            </p>
          </div>

          {overallScore >= 100 ? (
            <button
              style={{
                background: "#1976d2",
                color: "#fff",
                padding: "16px 32px",
                fontSize: "1.2rem",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                boxShadow: "0 4px 16px rgba(25, 118, 210, 0.15)",
                transition: "background 0.2s",
                marginTop: "16px"
              }}
              onClick={handleRedeem}
            >
              🎁 Redeem Points for Gift Voucher
            </button>
          ) : (
            <div style={{ color: "#c62828", fontSize: "1.1rem", marginTop: "16px" }}>
              A minimum of 100 points is required to redeem a gift voucher.
            </div>
          )}
        </div>
      )}
      <div style={{ height: "32px" }} />
    </div>
  );
}

export default MyScore;